import FilterSelect from './FilterSelect';
import FilterConfig from './FilterConfig';
import type { FilterHumanReadableType } from '../../types';
import { featureMakeMarkedSelectedFilterDescription } from './featureMakeMarkedSelectedFilterDescription';
import { Checkbox } from '../../../../shared/Checkbox/Checkbox';
import { _ } from '../../Lang.class.js';

interface HumanFriendlyRuleWithActionsCallbacks {
    onChangeSelect: (key: string, selectedIds: string[], reloadGroup: boolean) => void;
    onEdit: (key: string, descriptionDOMElement: HTMLElement) => void;
    onRemove: (key: string) => void;
    onToggleActive: (key: string, active: boolean) => void;
}

const HumanFriendlyRuleWithActions = (
    props: FilterHumanReadableType,
    callbacks: HumanFriendlyRuleWithActionsCallbacks
) => {
    const useFilterSelect = false;

    console.log('props?, HumanFriendlyRuleWithActions props', props);

    let div = document.createElement('div');
    div.style.display = 'flex';
    div.style.alignItems = 'center';

    let tagValueStart =
        '<span class="filter-description-item__value" data-id="HumanFriendlyRuleWithActions">';
    let tagValueEnd = '</span>';

    if (!useFilterSelect) {
        if (props.allAvailableEntries) {
            let selectedEntries = props.allAvailableEntries
                .filter((entry: { id: string | number; name: string }) => {
                    return props.selectedIds.includes(entry.id as never);
                })
                .map(entry => {
                    let entryName = _(entry.name);
                    return entryName.charAt(0).toLocaleLowerCase() + entryName.slice(1);
                });

            if (selectedEntries.length > 3) {
                props.description.filter_str +=
                    ' ' +
                    tagValueStart +
                    selectedEntries.slice(0, 2).join(', ') +
                    ' ' +
                    _('filter_and') +
                    ' ' +
                    (selectedEntries.length - 2) +
                    ' ' +
                    _('filter_others') +
                    tagValueEnd;
            } else {
                props.description.filter_str +=
                    ' ' + tagValueStart + selectedEntries.join(', ') + tagValueEnd;
            }
        } else {
            console.error('HumanFriendlyRuleWithActions: allAvailableEntries is not defined');
        }
    }

    /*
    <div class="js-edit filter-description-item__text" data-key="special_attributes.type">
                typu&nbsp;
                <span class="filter-description-item__value" data-id="_translateFilterStr" data-key="special_attributes.type" data-unit="">1, 2</span>
                <span class="filter-description-item__value" data-id="HumanFriendlyRuleWithActions">fit, do</span>
            </div>
     */

    // liczba szt. <span class="filter-description-item__value" data-key="special_attributes.parcels" data-unit="">&#8805;</span> <span class="filter-description-item__value" data-key="special_attributes.parcels" data-unit="">296</span> <span class="filter-description-item__value"></span>
    console.log('props?.description', props?.description);
    let text = props?.description.filter_str.replace(/(<span.+$)/g, '').trim();
    let values = props?.description.filter_str.match(/<span[^>]*>([^<]+)<\/span>/g);
    // get only last item from values
    if (values) values = [values[values?.length - 1]];
    console.log('props?.description text', text);
    console.log('props?.description values', values);

    let negation_tag_start = '';
    let negation_tag_end = '';
    if (props?.description.negation) {
        negation_tag_start = `<div class="negation" style="display: flex; align-items: center;" data-parent="HumanFriendlyRuleWithActions">${_('filter_not')} `;
        negation_tag_end = '&nbsp;</div>';
    }

    div.innerHTML = `
        <div class="filter-description-item mr-2">
            <div class="js-checkbox-active-queries">
            </div>
            <div class="js-edit filter-description-item__text" data-key="${props?.key}">
                ${negation_tag_start}
                ${_(text)}&nbsp;
                ${values ? values.join('') : ''}
                ${negation_tag_end}
            </div>
            <div class="filter-description-multi-select" ${useFilterSelect ? '' : 'style="display:none;"'}></div>
            <div class="filter-description-item__actions">
                <div class="js-remove">
<!--                    <img src="js/pages/telematics/components/FilterByParameters/images/close_FILL0_wght400_GRAD0_opsz48.svg" alt="close" />-->
                </div>
            </div>
        </div>
    `;

    if (useFilterSelect) {
        if (props?.displayMethod === FilterConfig.displayMethod.SELECT_MULTIPLE) {
            let filterSelect = div.querySelector('.filter-description-multi-select');
            if (filterSelect) {
                filterSelect.appendChild(
                    FilterSelect(
                        {
                            multiple: true,
                            allAvailableEntries: props.allAvailableEntries,
                            selectedIds: props.selectedIds,
                            parentRoot: div.querySelector(
                                '.filter-description-item'
                            ) as HTMLElement,
                        },
                        {
                            onChangeAndClose: selectedIds => {
                                callbacks.onChangeSelect(props?.key, selectedIds, true);
                                return true;
                            },
                            onChangeWhileOpen: selectedIds => {
                                callbacks.onChangeSelect(props?.key, selectedIds, false);
                                return true;
                            },
                        }
                    )
                );
            }
        }
    }

    let js_edit_element = div.querySelector('.js-edit');
    if (js_edit_element) {
        js_edit_element.addEventListener('click', () => {
            featureMakeMarkedSelectedFilterDescription.setActive(div, true);
            callbacks.onEdit(props?.key, div);
        });
    }

    let js_remove_element = div.querySelector('.js-remove');
    if (js_remove_element) {
        js_remove_element.addEventListener('click', () => {
            callbacks.onRemove(props?.key);
        });
    }

    if (props?.active !== null) {
        let checkbox = Checkbox(
            {
                label: '',
                checked: props.active,
                disabled: false,
                mode: 'black-checkbox',
            },
            {
                onChange: ch => {
                    callbacks.onToggleActive(props?.key, ch);
                },
            }
        );
        let js_checkbox_active_queries = div.querySelector('.js-checkbox-active-queries');
        if (js_checkbox_active_queries) {
            js_checkbox_active_queries.appendChild(checkbox.element);
        }
    }

    return div;
};

export default HumanFriendlyRuleWithActions;
